import React from 'react'
import { withRouter } from 'react-router'
import { ApiContent } from 'src/utils/getDataFromTree'
import { getCsEntries } from './utils'
// Side-effect import: the studio components' global styles reached the main
// stylesheet through this module (first imported from CartBlock/CartProducts).
// Keep it here so they stay at the same position in the cascade.
import 'src/views/studioComponents'

/**
 * Loads the ContentStack `equinox_pages` entry for the current URL into
 * `contentStackContainer.contentStackPage` (and the `csPageEntry` context on
 * the server). It renders nothing: the home-page MFE owns the zone content
 * that used to be rendered here.
 *
 * Keep the fetch. On the client, `NotFound` / `ContentStackPage` read
 * `contentStackContainer.contentStackPage` to decide which Visual Builder
 * micro frontend to mount and never fetch the entry themselves; this
 * component, mounted from `routes.js`, is their only client-side loader.
 */
class CSEntriesLoader extends React.Component {
  static contextType = ApiContent

  constructor(props, context) {
    super(props)
    this.context = context
    this.contextName = 'csPageEntry'
  }

  componentDidMount() {
    this.getContentStackPageEntries()
  }

  componentDidUpdate(prevProps) {
    if (this.getUrl(prevProps) !== this.getUrl(this.props)) {
      this.getContentStackPageEntries()
    }
  }

  getUrl = props => props?.url || props?.location?.pathname || ''

  getContentStackPageEntries = () => {
    getCsEntries({
      url: this.getUrl(this.props),
      context: this.context,
      contextName: this.contextName,
    })
  }

  render() {
    return null
  }
}

const CSWrapper = withRouter(CSEntriesLoader)
export { CSWrapper }
